import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {WSUnregisterPSLeakDevice} from "../types/WebSocketTypes"
import {unregisterPsLeakDeviceApi} from "../api/unregisterPsLeakDeviceApi"
import {UnregisterPSLeakDevicesResponse} from "../models/response"

export type UnregisterPSLeakDeviceFilter = {
    limit: number
    offset: number
    search?: string
}

type InitialStateType = {
    unregisterPsLeakDevices: null | UnregisterPSLeakDevicesResponse
    filter: UnregisterPSLeakDeviceFilter
    ws: WSUnregisterPSLeakDevice | null
}

const initialState: InitialStateType = {
    unregisterPsLeakDevices: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const unregisterPsLeakDeviceReducer = createSlice({
    name: "unregisterPsLeakDeviceReducer",
    initialState,
    reducers: {
        setUnregisterPSLeakDevices(state, {payload}) {
            state.unregisterPsLeakDevices = payload
        },
        setUnregisterPSLeakDeviceFilter(state, {payload}) {
            state.filter = payload
        },
        setWSUnregisterPSLeakDevice(state, {payload}: PayloadAction<WSUnregisterPSLeakDevice | null>) {
            state.ws = payload
        },
    },
})

export const {setUnregisterPSLeakDevices, setUnregisterPSLeakDeviceFilter, setWSUnregisterPSLeakDevice} = unregisterPsLeakDeviceReducer.actions

export default unregisterPsLeakDeviceReducer.reducer

export const getUnregisterPSLeakDevices = asyncCreator
("unregisterPsLeakDeviceReducer/getUnregisterPSLeakDevices", unregisterPsLeakDeviceApi.getDevices, setUnregisterPSLeakDevices)
